var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCnb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_82200",
    "data-name": "Group 82200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.724,
    height: 29.068,
    viewBox: "0 0 135.724 29.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20711",
    width: 135.724,
    height: 29.068,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_82200-2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30324",
    d: "M16.658,37.484c0-4.728-2.955-8.006-8.113-8.006-5.1,0-8.435,2.74-8.489,8.275L0,42.857c-.054,5.158,3.224,8.328,8.543,8.328,4.46,0,8.436-2.364,8.221-8.328H11.392c0,2.472-1.128,3.492-2.848,3.492a2.75,2.75,0,0,1-2.9-2.955V37.215a2.652,2.652,0,0,1,2.9-2.9c1.934,0,2.848,1.236,2.848,3.17Z",
    transform: "translate(0 -22.117)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30325",
    d: "M378.532.216h-5.266a1.7,1.7,0,0,0-1.88,1.558l-.86,4.084h5.051a1.825,1.825,0,0,0,2.1-1.558Z",
    transform: "translate(-278.002 -0.162)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30326",
    d: "M212.725,8.812a2.863,2.863,0,0,0-2.794,1.612L205.8,17.581l-5.857-6.889a5.76,5.76,0,0,1-1.773-3.654,2.134,2.134,0,0,1,2.364-2.31,2.414,2.414,0,0,1,2.579,2.633h5.266C208.481,4.567,206.654,0,200.582,0c-5,0-8.06,2.848-8.06,6.985a7.628,7.628,0,0,0,1.988,5.212l8.506,10.05a4.632,4.632,0,0,1-3.993,1.985,3.794,3.794,0,0,1-4.084-4.03,3.894,3.894,0,0,1,1.5-3.116l-3.654-4.3a8.567,8.567,0,0,0-3.654,7.2c0,5.212,3.761,9.08,9.833,9.08a9.435,9.435,0,0,0,7.323-2.95l2.134,2.521h6.77l-5.843-6.872,4.231-7.313a1.546,1.546,0,0,1,1.719-.967h4.084c1.29,0,1.881-.376,2.149-1.558l.645-3.116Z",
    transform: "translate(-141.908)",
    fill: "#f7e300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30327",
    d: "M427.095,52.155l-8.489-10.477,8.167-10.263h-6.233l-5.8,7.308-.86,4.137c-.161.806-.7,1.343-1.88,1.343h-2.955v8.006h5.642V44.418l6.179,7.737Z",
    transform: "translate(-306.899 -23.57)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30328",
    d: "M409.041,15.475h5.7L414.683.7V.43h-5.642Z",
    transform: "translate(-306.899 -0.323)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30329",
    d: "M314.023,36.141a6.832,6.832,0,0,0-7.093-6.663,5.383,5.383,0,0,0-1.827.269l-1.343,5.212a4.171,4.171,0,0,1,2.1-.537,2.584,2.584,0,0,1,2.633,2.687l-.054,5.964c0,1.666-.86,3.17-2.794,3.17-2.31,0-3.009-1.612-3.009-3.385V37.7c0-.268.054-.43.054-.806a3.428,3.428,0,0,1-1.666.322h-4.084v13.54H302.1l.269-1.4a6.887,6.887,0,0,0,4.782,1.827,6.381,6.381,0,0,0,6.77-6.179c.215-3.009.161-6.018.108-8.865",
    transform: "translate(-222.789 -22.117)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20709",
    width: 5.695,
    height: 7.146,
    transform: "translate(74.149 0.054)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30330",
    d: "M162.713,34.676V29.357a5.276,5.276,0,0,0-5.642,3.117l-.43-2.74h-4.3v20.9h5.588l.054-12.3c0-2.042,1.075-3.654,3.546-3.654Z",
    transform: "translate(-114.301 -21.996)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30331",
    d: "M486.865,43.341V43.5a2.641,2.641,0,0,1-2.9,2.847c-1.88,0-3.063-1.075-3.063-3.224V37.269a2.934,2.934,0,0,1,3.063-3.17c1.5,0,2.9,1.021,2.9,3.439H482.3V41.46h10.047V38.935c0-5.588-2.847-9.457-8.543-9.457-5.212,0-8.489,3.224-8.489,8.328v4.782c0,5.266,3.331,8.6,8.651,8.6,5.373,0,8.328-3.063,8.328-7.844Z",
    transform: "translate(-356.622 -22.117)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30332",
    d: "M90.355,36.678c0-4.406-3.546-7.2-8.274-7.2-4.352,0-8.06,2.418-8.06,8.006H79.34V37.43c0-2.15,1.021-3.331,2.794-3.331,2.149,0,2.633,1.666,2.633,3.331L84.713,43.5c0,2.149-1.021,3.277-2.955,3.277-1.236,0-2.579-.483-2.579-2.042,0-1.343.859-1.988,2.579-1.988h1.558V38.77l-3.224,0c-3.385.053-6.5,2.042-6.5,6.018a6.168,6.168,0,0,0,6.5,6.394,6.737,6.737,0,0,0,5-1.827l.269,1.4h5Z",
    transform: "translate(-55.215 -22.117)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20710",
    width: 5.534,
    height: 20.847,
    transform: "translate(93.707 7.791)",
    fill: "#000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnb);
export default __webpack_public_path__ + "static/media/cnb.fdf9c6251267554459b49907238dab0f.svg";
export { ForwardRef as ReactComponent };